import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ClipType } from "@air/api/types";
import { memo } from "react";
import { useSelector } from "react-redux";
import { ContentFooter } from "~/components/AssetModalV2/Content/Footer/components/ContentFooter";
import { VideoSettingsButton } from "~/components/AssetModalV2/Content/Footer/components/VideoSettingsButton";
import { PublicDownloadButton } from "~/components/AssetModalV2/Content/Footer/PublicAssetComponents/PublicDownloadButton";
import { PublicVideoControls } from "~/components/AssetModalV2/Content/Footer/PublicAssetComponents/PublicVideoControls";
import { centralizedClipTypeSelector } from "~/store/centralizedClip/selectors";
export const PublicAssetContentFooter = /*#__PURE__*/ memo(()=>{
    const clipType = useSelector(centralizedClipTypeSelector);
    const isVideo = clipType === ClipType.video;
    const isAudio = clipType === ClipType.audio;
    return /*#__PURE__*/ _jsx(ContentFooter, {
        leftControls: isVideo || isAudio ? /*#__PURE__*/ _jsx(PublicVideoControls, {}) : undefined,
        rightControls: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                isVideo && /*#__PURE__*/ _jsx(VideoSettingsButton, {}),
                /*#__PURE__*/ _jsx(PublicDownloadButton, {})
            ]
        })
    });
});
PublicAssetContentFooter.displayName = "PublicAssetContentFooter";
